import { Button } from '@intigral/shared/components/Button';
import { Upgrade } from '@intigral/ui';
import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import h from '../../helpers/common';
import useShowUpgradeBanner from '../../hooks/useShowUpgradeBanner';
import { __ } from '../../translations';
import user from '../..//helpers/user';
import { KIDSMODE } from '@libs/constants';

export const UpgradedBanner = (props) => {
    const { content: upgradedBannerFields } = props;
    const language = h.getLang();
    const navigate = useNavigate();
    const { showUpgradedBanner, checkShowUpgradedBanner } = useShowUpgradeBanner();

    useEffect(() => {
        checkShowUpgradedBanner(upgradedBannerFields?.operators, upgradedBannerFields?.guids);
    }, []);

    const upgradedLink = language === 'en' ? upgradedBannerFields?.link?.en : upgradedBannerFields?.link?.ar;
    const isKid = user.getProfileMode() === KIDSMODE.KID;

    // Render the Banner
    return (
        showUpgradedBanner && (
            <Upgrade
                logo={language === 'en' ? upgradedBannerFields?.logo?.en : upgradedBannerFields?.logo?.ar}
                text={language === 'en' ? __(upgradedBannerFields?.title?.en) : __(upgradedBannerFields?.title?.ar)}
                picture={
                    language === 'en' ? upgradedBannerFields?.background?.en : upgradedBannerFields?.background?.ar
                }
                list={
                    language === 'en'
                        ? upgradedBannerFields?.upgraded?.option?.en?.map((item) => {
                              return { text: __(item?.text) };
                          })
                        : upgradedBannerFields?.upgraded?.option?.ar?.map((item) => {
                              return { text: __(item?.text) };
                          })
                }
                variant={'page'}
                id={'upgraded-banner'}
            >
                <Button
                    primary
                    data-test-id="upgrade-button"
                    disabled={isKid}
                    {...(!isKid && { LinkComponent: 'a', href: upgradedLink })}
                >
                    {__('upgrade')}
                </Button>
                <Link
                    to={
                        language === 'en'
                            ? upgradedBannerFields?.learnMoreLink?.en
                            : upgradedBannerFields?.learnMoreLink?.ar
                    }
                    className="primary-brand"
                    data-test-id="learn-button"
                >
                    {__('learn_more')}
                </Link>
            </Upgrade>
        )
    );
};
